var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 280",
    enableBackground: "new 0 0 300 280",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.32,
    y: 83.32,
    fill: "#FFFFFF",
    width: 113.41,
    height: 113.41
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EA4535",
    points: "206.68,247.73 257.73,196.68 206.68,196.68  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.68,
    y: 83.32,
    fill: "#F9BC15",
    width: 51.04,
    height: 113.41
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.32,
    y: 196.68,
    fill: "#36A852",
    width: 113.41,
    height: 51.04
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C8140",
    d: "M42.27,196.68v34c0,9.43,7.62,17.04,17,17.04h34v-51.04H42.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3968B2",
    d: "M257.73,83.32V49.28c0-9.38-7.62-17-17-17h-34v51.04H257.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#557EBF",
    d: "M206.68,32.27H59.28c-9.38,0-17,7.62-17,17v147.41h51.04V83.32h113.41V32.27H206.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#557EBF",
    d: "M116.55,171.27c-4.25-2.86-7.15-7.03-8.79-12.58l9.85-4.04c0.88,3.41,2.44,6.02,4.67,7.91 c2.23,1.85,4.92,2.78,8.04,2.78c3.2,0,5.98-0.97,8.29-2.95c2.31-1.98,3.49-4.46,3.49-7.49c0-3.07-1.22-5.6-3.66-7.57 c-2.44-1.94-5.51-2.95-9.17-2.95h-5.68v-9.72h5.09c3.16,0,5.81-0.84,7.95-2.57c2.15-1.68,3.24-4.04,3.24-6.99 c0-2.65-0.97-4.76-2.9-6.31c-1.94-1.56-4.38-2.36-7.32-2.36c-2.9,0-5.18,0.76-6.9,2.31c-1.68,1.56-2.99,3.49-3.7,5.68l-9.72-4.04 c1.3-3.66,3.66-6.9,7.11-9.68c3.49-2.78,7.91-4.21,13.3-4.21c4,0,7.57,0.76,10.73,2.31c3.16,1.56,5.68,3.7,7.49,6.4 c1.81,2.74,2.69,5.81,2.69,9.22c0,3.49-0.84,6.4-2.52,8.84c-1.68,2.4-3.75,4.25-6.19,5.55v0.59c3.16,1.3,5.89,3.45,7.91,6.19 c2.06,2.78,3.07,6.06,3.07,9.93c0,3.87-0.97,7.28-2.95,10.31c-1.94,3.03-4.67,5.39-8.08,7.11c-3.45,1.73-7.32,2.61-11.61,2.61 C125.38,175.56,120.8,174.13,116.55,171.27z M176.97,122.45l-10.81,7.83l-5.39-8.21l19.36-13.97h7.45v65.94h-10.6V122.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.2a2e8bbfaaf382ed4457867763d21959.svg";
export { ForwardRef as ReactComponent };